module.exports = __webpack_public_path__ + "static/media/photo104.08586973.jpg";